import React from "react";
import "./Appbar.css";
import list from "./menu.png";
import close from "./close (1).png";
import logo from "../assets/logo.png";
import discord from "./discord (3).png";
import twitter from "./twitter (8).png";
function Appbar() {
  const [click, setClick] = React.useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  return (
    <>
      <div>
        <div
          className={click ? "main-container" : ""}
          onClick={() => Close()}
        />
        <nav className="navbar" onClick={(e) => e.stopPropagation()}>
          <div className="nav-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="nav__width">
                <a href="/" className="nav-logo">
                  <img className="bar__logo" src={logo} alt="" />
                </a>
              </div>
            </div>
            <div>
              <ul className={click ? "nav-menu active" : "nav-menu"}>
                <li className="nav-item">
                  <a
                    href="#Roadmap"
                    activeClassName="active"
                    className="nav-links"
                    onClick={click ? handleClick : null}
                  >
                    ROADMAP
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Team"
                    activeClassName="active"
                    className="nav-links"
                    onClick={click ? handleClick : null}
                  >
                    TEAM
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Faq"
                    activeClassName="active"
                    className="nav-links"
                    onClick={click ? handleClick : null}
                  >
                    FAQ
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="https://mint.alien-society.com/"
                    activeClassName="active"
                    className="nav-links"
                    onClick={click ? handleClick : null}
                  >
                    MINT
                  </a>
                </li>
              </ul>
            </div>
            <div onClick={handleClick}>
              <img
                src={click ? close : list}
                style={{ color: "white" }}
                className={click ? "nav-icon2" : "nav-icon"}
              ></img>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Appbar;
